import { useMemo } from 'react';

import SubActivityPrint from '../../sub-activity/sub-activity-print';
import InteractiveDragDisplay from '../../shared/interactive-drag-drop/interactive-drag-display';
import {
  InteractiveResponseTitle,
  InteractiveResponseViewScaler,
} from '../shared/interactive-response-shared';
import { InteractiveResponseContainer } from '../interactive-response.style';
import { ViewProps } from './settings/interactive-response.constants';
import { initialise } from './play/interactive-response-sequence.utils';
import { ComponentAspectRatio } from '../../shared/component-height/component-dimensions';
import { ComponentAbsoluteWrapper } from '../../shared/component-height/component-dimensions.style';
import { useContainerDimensions } from '../../shared/component-height/component-dimensions.hooks';
import { defaultDimensions } from '../interactive-response-shared.constants';
import InteractiveSequenceDropDisplay from './play/interactive-sequence-drop-display';
import {
  InteractiveResponsePreviewContainer,
  InteractiveStackDragContainer,
} from '../shared/interactive-response-shared.style';
import { InteractiveResponsePreviewDropItemContainer } from './play/interactive-response-sequence.style';

const InteractiveResponseSequencePreview = ({
  properties,
  subActivityProperties,
}: ViewProps) => {
  const { dragItems, dropItems } = useMemo(() => {
    return initialise(
      properties.interactiveResponse.variant,
      properties.interactiveResponse.items,
      true
    );
  }, [properties.interactiveResponse]);

  const { setContainerElement } = useContainerDimensions({
    aspectRatio: 16 / 9,
  });

  return (
    <SubActivityPrint subActivityDetails={subActivityProperties}>
      <InteractiveResponseContainer>
        <ComponentAspectRatio
          dimensions={properties.responseDimensionData || defaultDimensions}
        >
          <ComponentAbsoluteWrapper ref={setContainerElement}>
            <InteractiveResponseViewScaler>
              <InteractiveResponseTitle
                title={properties.interactiveResponse.title}
                subTitle={properties.interactiveResponse.subTitle}
              />

              <InteractiveResponsePreviewContainer>
                {dragItems.map((dragItem, index) => (
                  <InteractiveStackDragContainer
                    key={`${dragItem.id}-${index}`}
                    $index={index}
                  >
                    {!dragItem.isDropped && (
                      <InteractiveDragDisplay
                        imageUrl={dragItem.question.image?.small}
                        isFit={dragItem.question.image?.isFit}
                        description={dragItem.question.image?.description || ''}
                        baseColour={dragItem.question.baseColour}
                        variant={dragItem.question.variant}
                        text={dragItem.question.text}
                        richtext={dragItem.question.richtext}
                      />
                    )}
                  </InteractiveStackDragContainer>
                ))}
              </InteractiveResponsePreviewContainer>

              <InteractiveResponsePreviewDropItemContainer>
                {dropItems.map(dropItem => (
                  <InteractiveSequenceDropDisplay
                    key={`${dropItem.id}`}
                    label={dropItem.label}
                    labelLength={properties.interactiveResponse.labelLength}
                    labelBorder={properties.interactiveResponse.labelBorder}
                  />
                ))}
              </InteractiveResponsePreviewDropItemContainer>
            </InteractiveResponseViewScaler>
          </ComponentAbsoluteWrapper>
        </ComponentAspectRatio>
      </InteractiveResponseContainer>
    </SubActivityPrint>
  );
};

export default InteractiveResponseSequencePreview;
